<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,9C3,8.4,3.4,8,4,8C4.6,8,5,8.4,5,9C5,10.1,5.9,11,7,11C7.6,11,8,11.4,8,12C8,12.6,7.6,13,7,13C4.8,13,3,11.2,3,9C3,9,3,9,3,9ZM0,9C0,8.4,0.4,8,1,8C1.6,8,2,8.4,2,9C2,11.8,4.2,14,7,14C7.6,14,8,14.4,8,15C8,15.6,7.6,16,7,16C3.1,16,0,12.9,0,9C0,9,0,9,0,9ZM7,10C6.4,10,6,9.6,6,9C6,8.4,6.4,8,7,8C7.6,8,8,8.4,8,9C8,9.6,7.6,10,7,10C7,10,7,10,7,10ZM8.3,7.2C7.9,6.8,7.9,6.2,8.3,5.8C8.3,5.8,12.8,1.3,12.8,1.3C13.2,0.9,13.8,0.9,14.2,1.3C14.2,1.3,14.7,1.8,14.7,1.8C15.1,2.2,15.1,2.8,14.7,3.2C14.7,3.2,10.2,7.7,10.2,7.7C9.8,8.1,9.2,8.1,8.8,7.7C8.8,7.7,8.3,7.2,8.3,7.2C8.3,7.2,8.3,7.2,8.3,7.2ZM5.2,0.3C5.6,-0.1,6.2,-0.1,6.6,0.3C6.6,0.3,8.7,2.4,8.7,2.4C9.1,2.8,9.1,3.4,8.7,3.8C8.7,3.8,7.8,4.7,7.8,4.7C7.4,5.1,6.8,5.1,6.4,4.7C6.4,4.7,4.3,2.6,4.3,2.6C3.9,2.2,3.9,1.6,4.3,1.2C4.3,1.2,5.2,0.3,5.2,0.3C5.2,0.3,5.2,0.3,5.2,0.3ZM12.2,7.3C12.6,6.9,13.2,6.9,13.6,7.3C13.6,7.3,15.7,9.4,15.7,9.4C16.1,9.8,16.1,10.4,15.7,10.8C15.7,10.8,14.8,11.7,14.8,11.7C14.4,12.1,13.8,12.1,13.4,11.7C13.4,11.7,11.3,9.6,11.3,9.6C10.9,9.2,10.9,8.6,11.3,8.2C11.3,8.2,12.2,7.3,12.2,7.3C12.2,7.3,12.2,7.3,12.2,7.3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Satellite',
} as DefineComponent
</script>
